import { REGEXES } from '@/utils/key-regex.constants'

export const VALIDATION_PATTERNS = Object.freeze({
  CUSTOM: 'custom',
  PHONE: 'phone',
  EMAIL: 'email',
  NONE: 'none'
})

export const VALIDATION_PARAMS = Object.freeze({
  email: {
    pattern: VALIDATION_PATTERNS.EMAIL,
    errorMessage: 'Enter your email, e.g. john@doe.com.',
    regex: REGEXES.EMAIL.source,
    defaultPrefix: null,
    label: 'Email'
  },
  phone: {
    pattern: VALIDATION_PATTERNS.PHONE,
    errorMessage: 'Enter your phone number.',
    regex: REGEXES.NUMBERS_AND_SPACES.source,
    defaultPrefix: '+420',
    label: 'Phone'
  },
  custom: {
    pattern: VALIDATION_PATTERNS.CUSTOM,
    errorMessage: '',
    regex: '',
    defaultPrefix: null,
    label: ''
  },
  none: {
    pattern: VALIDATION_PATTERNS.NONE
  }
})
